import {PlanTypeEnum} from 'presentation/constants/bookingTypesEnum';
import {create} from 'zustand';
import {GuideStore} from './types';

export const useGuideStore = create<GuideStore>(set => ({
	searchByProviderName: {
		[PlanTypeEnum.HEALTH]: '',
		[PlanTypeEnum.ODONTO]: '',
		[PlanTypeEnum.HEALTH_ODONTO]: '',
	},
	activeStep: {
		[PlanTypeEnum.HEALTH]: 0,
		[PlanTypeEnum.ODONTO]: 0,
		[PlanTypeEnum.HEALTH_ODONTO]: 0,
	},
	selectedDistrict: '',
	coordinates: null,

	setSearchByProviderName: (type, value) =>
		set(state => ({
			searchByProviderName: {...state.searchByProviderName, [type]: value},
		})),

	setSelectedDistrict: value => set({selectedDistrict: value}),
	resetHealthStates: () =>
		set(state => ({
			searchByProviderName: {
				...state.searchByProviderName,
				[PlanTypeEnum.HEALTH]: '',
			},
			activeStep: {...state.activeStep, [PlanTypeEnum.HEALTH]: 0},
			selectedDistrict: '',
		})),
	resetOdontoStates: () => {
		set(state => ({
			searchByProviderName: {
				...state.searchByProviderName,
				[PlanTypeEnum.ODONTO]: '',
				[PlanTypeEnum.HEALTH_ODONTO]: '',
			},
			activeStep: {
				...state.activeStep,
				[PlanTypeEnum.ODONTO]: 0,
				[PlanTypeEnum.HEALTH_ODONTO]: 0,
			},
			selectedDistrict: '',
		}));
	},
	setCoordinates: value => set({coordinates: value}),
}));
